import { render, staticRenderFns } from "./content-info.vue?vue&type=template&id=7b091288&scoped=true&"
import script from "./content-info.ts?vue&type=script&lang=ts&"
export * from "./content-info.ts?vue&type=script&lang=ts&"
import style0 from "./content-info.scss?vue&type=style&index=0&id=7b091288&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b091288",
  null
  
)

export default component.exports